<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<h3 #chartTitle></h3>
<canvas #chartCanvas ></canvas>